(() => {
  const products = [
    { match: 'shock collar', name: 'Shock Collar', role: 'High-stim training', reason: 'Bring high-stim intensity when caffeine fits the session.' },
    { match: 'bite down', name: 'Bite Down', role: 'Caffeine-free training', reason: 'Add pump and training support without adding caffeine.' },
    { match: 'buffdawg', name: 'BuffDawg', role: 'Daily creatine', reason: 'Add five grams of creatine to the daily foundation.' },
    { match: 'hotdawg', name: 'HotDawg', role: 'Thermogenic support', reason: 'Add the thermogenic-support side of the routine.' },
    { match: 'ruff night', name: 'Ruff Night', role: 'Melatonin-free evening support', reason: 'Finish the routine with melatonin-free nighttime support.' },
    { match: 'sportshaker', name: 'SportShaker', role: 'Training gear', reason: 'Keep the stack mixed and ready for the gym.' },
  ];

  const styles = `
    [data-sd-original-upsell]{display:none!important}
    .kaching-cart__checkout-button{background:#111!important;border-color:#111!important;color:#fff!important}
    .kaching-cart__checkout-button:hover{background:#000!important;border-color:#000!important}
    .kaching-cart .kaching-cart__tiered-promotions-bar-icon-tooltip-title,.kaching-cart__tiered-promotions-bar-icon-tooltip .kaching-cart__tiered-promotions-bar-icon-tooltip-title{color:#111!important}
    .kaching-cart__tiered-promotions-bar-icon svg circle{fill:#111!important;stroke:#111!important}
    .kaching-cart__tiered-promotions-bar-icon svg path{stroke:#111!important}
    .kaching-cart__badge{background:#111!important;border-color:#111!important;color:#fff!important}
    .kaching-cart__badge *{color:#fff!important}
    [data-sd-stack]{background:#0a0a0a!important;border:0!important;border-radius:0!important;color:#fff!important;margin:14px 0 18px!important;overflow:hidden!important;padding:0!important}
    [data-sd-stack-head]{border-bottom:1px solid #3c3c3c;padding:18px 16px 15px}
    [data-sd-stack-kicker]{color:#aaa;font-size:9px;font-weight:900;letter-spacing:.15em;margin:0 0 7px;text-transform:uppercase}
    [data-sd-stack-head] h3{color:#fff!important;font-size:21px!important;font-weight:900!important;letter-spacing:-.035em!important;line-height:.95!important;margin:0!important;text-transform:uppercase!important}
    [data-sd-stack-head] p:last-child{color:#bdbdbd!important;font-size:11px!important;line-height:1.45!important;margin:9px 0 0!important}
    [data-sd-stack-context]{background:#fff;color:#111;display:grid;gap:3px;padding:11px 16px}
    [data-sd-stack-context] span{color:#666;font-size:8px;font-weight:900;letter-spacing:.12em;text-transform:uppercase}
    [data-sd-stack-context] strong{font-size:11px;line-height:1.35;text-transform:uppercase}
    [data-sd-stack-list]{display:grid;gap:1px;background:#383838;padding:1px}
    [data-sd-stack-card]{background:#151515;display:grid;gap:12px;grid-template-columns:78px minmax(0,1fr);padding:13px;position:relative}
    [data-sd-stack-card][data-best="true"]{background:#fff;color:#111}
    [data-sd-stack-card][data-best="true"]:before{background:#111;color:#fff;content:'BEST MATCH';font-size:7px;font-weight:900;letter-spacing:.12em;padding:4px 6px;position:absolute;right:0;top:0}
    [data-sd-stack-image]{align-self:start;background:#eee;display:block;height:88px;object-fit:contain;width:78px}
    [data-sd-stack-info]{min-width:0;padding-top:2px}
    [data-sd-stack-role]{color:#999;display:block;font-size:8px;font-weight:900;letter-spacing:.12em;margin-bottom:4px;text-transform:uppercase}
    [data-best="true"] [data-sd-stack-role]{color:#666}
    [data-sd-stack-title]{color:inherit!important;display:block;font-size:14px!important;font-weight:900!important;line-height:1.15!important;margin:0 0 5px!important;text-decoration:none!important;text-transform:uppercase!important}
    [data-sd-stack-reason]{color:#aaa!important;font-size:10px!important;line-height:1.4!important;margin:0 0 7px!important}
    [data-best="true"] [data-sd-stack-reason]{color:#555!important}
    [data-sd-stack-price]{color:inherit!important;display:block;font-size:12px;font-weight:900;margin-bottom:8px}
    [data-sd-stack-controls]{display:grid;gap:7px}
    [data-sd-stack-select]{appearance:auto;background:#fff;border:1px solid #777;border-radius:0;color:#111;font-size:10px;height:36px;padding:0 8px;width:100%}
    [data-sd-stack-add]{background:#fff;border:2px solid #fff;border-radius:0;color:#111;cursor:pointer;font-size:9px;font-weight:900;letter-spacing:.09em;min-height:38px;padding:7px;text-transform:uppercase;width:100%}
    [data-best="true"] [data-sd-stack-add]{background:#111;border-color:#111;color:#fff}
    [data-sd-stack-add]:hover{background:#bbb;border-color:#bbb;color:#111}
    [data-sd-stack-foot]{border-top:1px solid #383838;color:#aaa;font-size:9px;line-height:1.45;margin:0;padding:11px 16px}
    @media(min-width:520px){[data-sd-stack-card]{grid-template-columns:92px minmax(0,1fr)}[data-sd-stack-image]{height:102px;width:92px}}
  `;

  function productFor(text) {
    const normalized = text.toLowerCase();
    return products.find((product) => normalized.includes(product.match));
  }

  function selectedVariant(source) {
    const select = source?.querySelector('select');
    const selected = select?.selectedOptions?.[0];
    const href = source?.querySelector('a[href*="variant="]')?.href || '';
    let urlVariant = '';
    try {
      urlVariant = new URL(href, window.location.origin).searchParams.get('variant') || '';
    } catch {
      urlVariant = '';
    }
    return { id: String(select?.value || urlVariant || ''), label: String(selected?.textContent || source?.textContent || '').toLowerCase() };
  }

  function imageFor(product, source, override = {}) {
    const entry = window.SuppDawgCartImages?.products?.[product?.match];
    if (!entry) return null;
    const selected = selectedVariant(source);
    const id = String(override.id || selected.id || '');
    const label = String(override.label || selected.label || '').toLowerCase();
    if (entry.variants?.[id]) return entry.variants[id];
    const flavor = Object.keys(entry.flavors || {}).find((key) => label.includes(key));
    return (flavor && entry.flavors[flavor]) || entry.default || null;
  }

  function setImage(image, data) {
    if (!image || !data?.src) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = data.src;
    image.alt = data.alt || image.alt || 'SuppDawg product';
    image.loading = 'eager';
  }

  function updateCartItemImages(root) {
    root.querySelectorAll('.kaching-cart-item').forEach((item) => {
      const product = productFor(item.textContent);
      const data = imageFor(product, item);
      const images = [...item.querySelectorAll('img')].filter((image) => !/payment|icon|logo/i.test(`${image.alt} ${image.src}`));
      images.forEach((image) => setImage(image, data));
      item.querySelectorAll('picture source').forEach((source) => { if (data?.src) source.srcset = data.src; });
    });
  }

  function cartText(root) {
    return [...root.querySelectorAll('.kaching-cart-item')].map((item) => item.textContent).join(' ').toLowerCase();
  }

  function contextFor(text) {
    if (text.includes('shock collar') || text.includes('bite down')) return 'Training is covered. Add a daily foundation or evening role.';
    if (text.includes('buffdawg')) return 'Your daily foundation is covered. Add training or evening support.';
    if (text.includes('hotdawg')) return 'Thermogenic support is covered. Add training, daily or evening support.';
    if (text.includes('ruff night')) return 'Evening support is covered. Add a training or daily role.';
    return 'Choose the one role your current routine is missing.';
  }

  function preferredOrder(text) {
    if (text.includes('shock collar') || text.includes('bite down')) return ['ruff night', 'buffdawg', 'sportshaker'];
    if (text.includes('buffdawg')) return ['bite down', 'ruff night', 'hotdawg', 'shock collar'];
    if (text.includes('hotdawg')) return ['bite down', 'ruff night', 'buffdawg'];
    if (text.includes('ruff night')) return ['bite down', 'buffdawg', 'shock collar'];
    return products.map((product) => product.match);
  }

  function makeCard(root, original, product, isBest) {
    const card = document.createElement('article');
    card.dataset.sdStackCard = 'true';
    card.dataset.best = isBest ? 'true' : 'false';

    const sourceImage = original.querySelector('img');
    const mappedImage = imageFor(product, original);
    const image = document.createElement('img');
    image.dataset.sdStackImage = 'true';
    image.src = mappedImage?.src || sourceImage?.currentSrc || sourceImage?.src || '';
    image.alt = mappedImage?.alt || sourceImage?.alt || `${product.name} by SuppDawg`;
    image.width = 92;
    image.height = 102;

    const info = document.createElement('div');
    info.dataset.sdStackInfo = 'true';
    const role = document.createElement('span');
    role.dataset.sdStackRole = 'true';
    role.textContent = product.role;
    const titleSource = [...original.querySelectorAll('a')].find((link) => productFor(link.textContent));
    const title = document.createElement('a');
    title.dataset.sdStackTitle = 'true';
    title.href = titleSource?.href || '#';
    title.textContent = product.name;
    const reason = document.createElement('p');
    reason.dataset.sdStackReason = 'true';
    reason.textContent = product.reason;
    const price = document.createElement('strong');
    price.dataset.sdStackPrice = 'true';
    price.textContent = original.textContent.match(/\$\d+(?:\.\d{2})?/)?.[0] || '';
    const controls = document.createElement('div');
    controls.dataset.sdStackControls = 'true';

    const originalSelect = original.querySelector('select');
    if (originalSelect) {
      const select = document.createElement('select');
      select.dataset.sdStackSelect = 'true';
      select.setAttribute('aria-label', `${product.name} option`);
      [...originalSelect.options].forEach((option) => select.add(new Option(option.text, option.value, option.defaultSelected, option.selected)));
      select.addEventListener('change', () => {
        originalSelect.value = select.value;
        originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
        setImage(image, imageFor(product, original, { id: select.value, label: select.selectedOptions?.[0]?.textContent || '' }));
      });
      controls.appendChild(select);
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.sdStackAdd = 'true';
    button.textContent = `Add ${product.name}`;
    button.addEventListener('click', () => original.querySelector('.kaching-product-upsell-item__add-to-cart')?.click());
    controls.appendChild(button);
    info.append(role, title, reason, price, controls);
    card.append(image, info);
    return card;
  }

  function build(root) {
    if (root.getAttribute('data-open') !== 'true') return;
    updateCartItemImages(root);
    const originals = [...root.querySelectorAll('.kaching-product-upsell-item')];
    if (!originals.length) return;
    const list = originals[0].closest('ul') || originals[0].parentElement;
    if (!list) return;
    const cart = cartText(root);
    const signature = cart + '|' + originals.map((card) => [card.textContent.replace(/\s+/g, ' ').trim(), card.dataset.variantId, card.querySelector('select')?.value].join(':')).join('|');
    const existing = root.querySelector('[data-sd-stack]');
    if (existing?.dataset.signature === signature) return;
    existing?.remove();

    if (!root.querySelector('#suppdawg-cart-aov-styles')) {
      const style = document.createElement('style');
      style.id = 'suppdawg-cart-aov-styles';
      style.textContent = styles;
      root.appendChild(style);
    }

    list.dataset.sdOriginalUpsell = 'true';
    const module = list.closest('.kaching-upsell-module--product-upsell');
    module?.querySelectorAll('.kaching-cart-product-upsell-carousel__title, .kaching-cart__carousel-nav-button').forEach((node) => {
      node.dataset.sdOriginalUpsell = 'true';
    });
    let headingNode = list.previousElementSibling;
    for (let step = 0; headingNode && step < 4; step += 1, headingNode = headingNode.previousElementSibling) {
      if (/grab this before checkout|grab this before you go|make the ultimate combo/i.test(headingNode.textContent.trim())) {
        headingNode.dataset.sdOriginalUpsell = 'true';
        break;
      }
    }
    const order = preferredOrder(cart);
    const available = originals.map((original) => ({ original, product: productFor(original.textContent) })).filter((item) => item.product);
    const rank = (product) => { const index = order.indexOf(product.match); return index < 0 ? order.length : index; };
    available.sort((a, b) => rank(a.product) - rank(b.product));

    const panel = document.createElement('section');
    panel.dataset.sdStack = 'true';
    panel.dataset.signature = signature;
    panel.setAttribute('aria-label', 'Complete your SuppDawg stack');
    panel.innerHTML = `<header data-sd-stack-head><p data-sd-stack-kicker>Recommended for your routine</p><h3>Finish Your Stack</h3><p>One smart addition beats a random cart. Choose by the job your routine is missing.</p></header><div data-sd-stack-context><span>Your cart already covers</span><strong>${contextFor(cart)}</strong></div><div data-sd-stack-list></div><p data-sd-stack-foot>No fake countdowns. Add only what fits your training and review the full cart before checkout.</p>`;
    const customList = panel.querySelector('[data-sd-stack-list]');
    available.slice(0, 3).forEach((item, index) => customList.appendChild(makeCard(root, item.original, item.product, index === 0)));
    list.insertAdjacentElement('beforebegin', panel);
  }

  let drawer = null;
  let drawerObserver = null;
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      if (drawer?.isConnected) build(drawer);
    });
  };
  const connectDrawer = () => {
    const next = document.getElementById('kaching-cart');
    if (next === drawer) return;
    drawerObserver?.disconnect();
    drawer?.removeEventListener('change', queue);
    drawer = next;
    if (!drawer) return;
    drawerObserver = new MutationObserver(queue);
    drawerObserver.observe(drawer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-open', 'data-variant-id'] });
    drawer.addEventListener('change', queue);
    queue();
  };
  document.addEventListener('DOMContentLoaded', connectDrawer, { once: true });
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!event.target.closest?.('#cart-icon-bubble-mobile')) return;
    const headerCart = document.getElementById('cart-icon-bubble');
    if (!drawer?.isConnected || !headerCart) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (drawer.getAttribute('data-open') !== 'true') headerCart.click();
  }, true);
  new MutationObserver((records) => {
    if (drawer?.isConnected) return;
    if (records.some((record) => record.addedNodes.length || record.removedNodes.length)) connectDrawer();
  }).observe(document.documentElement, { childList: true, subtree: true });
  connectDrawer();
})();
